import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectTilesState } from 'widgets/tiles/store/selectors';
import {
    initialTilesConfigState,
    CapsuleContainerWidgetConfigState,
} from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';

export const buildTilesConfigSlice = () =>
    buildConfigSlice<CapsuleContainerWidgetConfigState>(
        WidgetType.TILES,
        selectTilesState,
        initialTilesConfigState
    );

export const useTilesConfigSlice = () =>
    useConfigSlice(buildTilesConfigSlice());

export type TilesConfigPayloadType =
    WidgetConfigSliceActionPayloadType<CapsuleContainerWidgetConfigState>;
